import modals from './modals';

export default {
  namespaced: true,
  modules   : {
    modals,
  },
  state: {
    loading      : false,
    url          : process.env.VUE_APP_BASE_URL,
    pageFocus    : true,
    footerLinks  : [],
    learningRules: '',
  },
  getters: {
    loading     : ({loading}) => loading,
    get_selected: () => (array) => {
      let child = array.filter((i) => i.selected)[0];
      return child ? child : array[0];
    },
    find_in_array: () => (array, id) => {
      return array.filter((i) => parseInt(i.id) === parseInt(id))[0];
    },
    find_by_option: () => (array, text, option = 'text') => {
      return array.filter((i) => i[option] === text)[0];
    },
    footer_links  : ({footerLinks}) => footerLinks,
    learning_rules: ({learningRules}) => learningRules,
  },
  mutations: {
    SET_STATE_COMMON(state, {key, value}) {
      state[key] = value;
    },
    LOADING_ON(state) {
      state.loading = true;
    },
    LOADING_OFF(state) {
      state.loading = false;
    },
    SET_FOOTER_LINKS(state, footerLinks) {
      state.footerLinks = footerLinks;
    },
    SET_LEARNING_RULES(state, learningRules) {
      state.learningRules = learningRules;
    },
  },
};
